import { render, staticRenderFns } from "./UpgradeMemberGuard.vue?vue&type=template&id=43c67cdf"
import script from "./UpgradeMemberGuard.vue?vue&type=script&lang=js"
export * from "./UpgradeMemberGuard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProjectLink: require('D:/private/personal-finance/src/components/Common/ProjectLink.vue').default})
